import React from "react";
import Avatar, { AvatarSize } from "../Avatar";
import styles from "./user.module.scss";
import UserIdVerifiedIcon from "../idVerified";
import classNames from "classnames";

export interface IUserInfo {
  name?: string;
  subheader?: string;
  phoneNumber?: string;
  imageUrl?: string;
  nationalIdVerified?: boolean;
  userAction?: () => void;
  userActionText?: string;
  type?: string;
}

export const User = ({
  name = "",
  subheader = "",
  phoneNumber = "",
  imageUrl = "",
  nationalIdVerified,
  userAction,
  userActionText,
  type,
}: IUserInfo): JSX.Element => {
  return (
    <div className={styles.userInfoContainer}>
      <div className={styles.userProfileImg}>
        <Avatar avatarSize={AvatarSize.SMALL} src={imageUrl} alt={name} />
        {nationalIdVerified !== undefined && (
          <div className={styles["national_verified"]}>
            <UserIdVerifiedIcon nationalIdVerified={nationalIdVerified} />
          </div>
        )}
      </div>
      <div
        style={{
          marginTop: subheader !== "" ? "0.5rem" : 0,
          gap: subheader !== "" ? "0px" : "8px",
        }}
        className={styles.userInfo}>
        <p className={"subtitle2"}>{name}</p>
        {subheader !== "" && (
          <p dir="ltr" className={styles["subheader"]}>
            {subheader}
          </p>
        )}
        <div
          dir="ltr"
          className={classNames(styles["hint2"], styles["phone_number"], {
            [styles["vertical_align"]]: !!type,
          })}>
          {type && (
            <div className={styles["user_type"]}>
              <p className={styles["m0"]}>{type}</p>
            </div>
          )}
          {phoneNumber}
          {userAction && (
            <div
              onClick={userAction}
              className={classNames(
                styles["pointer"],
                styles["action_button"]
              )}>
              <p className={styles["m0"]}>{userActionText}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default User;
